export default {
  root: {
    marginTop: -9,
    marginBottom: -9,
  },
}
